import React from 'react';

export const GroupedMarker = ({
  group,
  coordKey,
  isExpanded = false,
  onToggle = () => {},
  color = null,
  // Planning mode passes the count of members visible under the current filter
  // (slider / tier checkboxes) so the bubble never overstates what's there.
  count = null,
  // Optional px boost to visually emphasise high-priority groups (Tier 2/3).
  sizeBoost = 0,
}) => {
  const shownCount = count ?? group.markers.length;
  const baseColorStyle = color ? { backgroundColor: color, borderColor: color } : undefined;
  const colorStyle = (baseColorStyle && !isExpanded && sizeBoost > 0)
    ? { ...baseColorStyle, width: `${30 + sizeBoost}px`, height: `${30 + sizeBoost}px` }
    : baseColorStyle;
  const stopMapEvent = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent?.stopImmediatePropagation?.();
  };

  const handleToggle = (e) => {
    stopMapEvent(e);
    onToggle(coordKey, !isExpanded);
  };

  const markerEvents = {
    onPointerDownCapture: stopMapEvent,
    onMouseDownCapture: stopMapEvent,
    onMouseUpCapture: stopMapEvent,
    onContextMenuCapture: stopMapEvent,
  };

  if (isExpanded) {
    return (
      <div className="grouped-marker-center" onClickCapture={handleToggle} {...markerEvents} style={colorStyle}>
        {shownCount}
      </div>
    );
  }

  return (
    <div className="grouped-marker" onClickCapture={handleToggle} {...markerEvents} style={colorStyle}>
      {shownCount}
    </div>
  );
};
